module.exports = __webpack_public_path__ + "img/u16.d298b5b9.png";